import cn from 'classnames';
import React from 'react';
import CloseLarge from 'wix-ui-icons-common/system/CloseLarge';
import { DH } from '../../utils/DataHook';
import * as s from './styles.scss';

export interface ModalProps {
  width: number | string;
  height: number | string;
  onClose?(): void;
}

export class Modal extends React.Component<ModalProps> {
  componentDidMount() {
    document.addEventListener('keydown', this.handleEscapeKeyPress);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscapeKeyPress);
  }

  handleEscapeKeyPress = (ev) => {
    if (ev.key === 'Escape' && this.props.onClose) {
      this.props.onClose();
    }
  };

  render() {
    const { width, height } = this.props;
    return (
      <div
        data-hook={DH.ModalLayout.Modal}
        className={s.modal}
        style={{ width, height }}
      >
        {this.props.children}
      </div>
    );
  }
}

export const Overlay: React.FunctionComponent<{
  dataHook?: string;
  isVisible?: boolean;
  onClick(): void;
}> = (props) => (
  <div
    data-hook={props.dataHook || null}
    className={s.overlay}
    hidden={props.isVisible === false}
    onClick={(ev) => {
      if (ev.target === ev.currentTarget) {
        props.onClick();
      }
    }}
  >
    {props.children}
  </div>
);
Overlay.displayName = 'Overlay';

export const Container: React.FunctionComponent<{ dataHook?: string }> = (
  props
) => (
  <div data-hook={props.dataHook} className={s.container}>
    {props.children}
  </div>
);
Container.displayName = 'Container';

export const Header: React.FunctionComponent<{ isRTL: boolean }> = (props) => (
  <header
    data-hook={DH.ModalLayout.Header}
    data-text-dir={props.isRTL ? 'rtl' : 'ltr'}
    className={cn(s.header, !!props.isRTL && s.rtl)}
  >
    {props.children}
  </header>
);
Header.displayName = 'Header';

export const Title: React.FunctionComponent = (props) => (
  <span data-hook={DH.ModalLayout.Title}>{props.children}</span>
);
Title.displayName = 'Title';

export const CloseButton: React.FunctionComponent<{ onClick(): void }> = (
  props
) => (
  <button
    className={s.closeButton}
    data-hook={DH.ModalLayout.CloseButton}
    aria-label="close"
    onClick={() => props.onClick()}
  >
    <CloseLarge size="16" />
  </button>
);
CloseButton.displayName = 'CloseButton';

export const Body: React.FunctionComponent = (props) => (
  <main className={s.body}>{props.children}</main>
);
Body.displayName = 'Body';
